<template>
  <div id="exit-save">
    <b-modal
      id="modal-exit-save"
      @hide="close"
      :noCloseOnBackdrop="true"
      :noCloseOnEsc="true"
      centered
    >

      <svg width="128px" height="128px" viewBox="0 0 128 128" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g  transform="translate(-248.000000, -117.000000)" fill-rule="nonzero">
            <g  transform="translate(48.000000, 117.000000)">
              <g  transform="translate(200.000000, 0.000000)">
                <path d="M120,0 L24,0 C19.578,0 16,3.582 16,8 L16,30.234 C18.367,28.101 21.063,26.496 24,25.453 L24,8 L120,8 L120,120 L24,120 L24,102.547 C21.062,101.504 18.367,99.899 16,97.766 L16,120 C16,124.418 19.578,128 24,128 L120,128 C124.422,128 128,124.418 128,120 L128,8 C128,3.582 124.422,0 120,0 Z"  fill="#B0BEC5"></path>
                <path d="M32,40 C34.047,40 36.094,40.781 37.656,42.344 C40.781,45.469 40.781,50.532 37.656,53.657 L35.313,56 L64,56 C68.422,56 72,59.582 72,64 C72,68.418 68.422,72 64,72 L35.313,72 L37.657,74.344 C40.782,77.469 40.782,82.532 37.657,85.657 C36.094,87.219 34.047,88 32,88 C29.953,88 27.906,87.219 26.344,85.656 L10.344,69.656 C7.219,66.531 7.219,61.468 10.344,58.343 L26.344,42.343 C27.906,40.781 29.953,40 32,40 M32,32 C27.727,32 23.711,33.664 20.687,36.688 L4.687,52.688 C1.664,55.711 0,59.727 0,64 C0,68.273 1.664,72.289 4.688,75.313 L20.688,91.313 C23.711,94.336 27.727,96 32,96 C36.273,96 40.289,94.336 43.313,91.312 C46.43,88.195 47.993,84.097 47.993,79.999 L64,79.999 C72.82,79.999 80,72.823 80,63.999 C80,55.179 72.82,47.999 64,47.999 L47.992,47.999 C47.992,43.901 46.429,39.804 43.312,36.686 C40.289,33.664 36.273,32 32,32 L32,32 Z"  fill="#F44336"></path>
                <path d="M104,24 L104,104 L96,104 L96,24 L104,24 M112,16 L88,16 L88,112 L112,112 L112,16 L112,16 Z"  fill="#EF9A9A"></path>
              </g>
            </g>
          </g>
        </g>
      </svg>

      <p class="mt-4 mb-2 title">
        <strong> {{ $t('exitSave.exitEditor') }} </strong>
      </p>
      <p class="my-2 subtitle">
        {{ $t('exitSave.exitPage') }}
      </p>
      <template v-slot:modal-footer>

        <button class="btn btn-primary" size="xl"  @click="back">
          {{$t('button.exit')}}
        </button>
        <button class="btn outline-secondary" size="xl" @click="close">
          {{ $t('button.cancel') }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import mixin from '../../mixins/Mixin.js';
  export default {
    name: 'ExitSave',
    data() {
      return {
        defaultUrl: false,
        defaultUrlGeneric: false,
        defaultUrlConclusion: false,
        isSubmited: false,
        type: '',
      };
    },
    computed: {
      /**
       * Getters from Vuex Store
       */
      ...mapGetters({
        paramsClient: 'getParamsClients',
        segment: 'segments/getCurrent',

      }),

    },
    mixins: [mixin],
    mounted() {

    },
    methods: {
      ...mapActions('segments', ['setSegmentsGeneric']),

      close() {
        this.$root.$emit('bv::hide::modal', 'modal-exit-save');
      },
      back() {
        this.$root.$emit('bv::hide::modal', 'modal-exit-save');
        this.$router.push({ name: 'ListSegment'});
      },
    },
  };
</script>

<style lang="scss">
  $secondary-color:#979797;

  #exit-save {
    #modal-exit-save {
      &___BV_modal_header_ {
        border: none !important;
        padding-bottom: 0;
        .close {
          float: right;
          font-size: 2.1rem;
          font-weight: 100;
          line-height: 1;
          color: #999;
          text-shadow: 0 1px 0 #fff;
          opacity: 0.5;
          &:focus {
            outline: none;
          }
        }
      }
      &___BV_modal_content_ {
        .subtitle {
          font-size: 14px;
          color: #888888;
        }
      }

      &___BV_modal_footer_ {
        border-top: 1px solid #c5c5c5;
        .btn-primary {
          border-radius: 0.1rem;
          font-size: 15px;
          width: 100px;

          &:focus {
            box-shadow: none;
          }

        }
        .outline-secondary {
          color:$secondary-color !important;
          background-color: #ffffff !important;
          border-color: $secondary-color !important;
          border-radius: 0.1rem;
          font-size: 15px;
          width: 100px;

          &:hover{
            background-color:$secondary-color !important ;
            color:#ffffff !important;

          }
          &:focus {
            box-shadow: none;
          }
        }
      }
      .modal-dialog.modal-md.modal-dialog-centered {
        max-width: 600px !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ExitSave.vue?e9bb35c4